import { Component, OnChanges } from '@angular/core';
import * as debug from 'debug';
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import cardMap from '@app/games/shared/card-map';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
const MersenneTwister = require('mersennetwister');

const log = debug('edg:reply-video-poker');

@Component({
  selector: 'app-reply-video-poker',
  template: `
    <div class="reply-loader" *ngIf="_loading || !data">
      <i class="fal fa-spinner fa-spin" [hidden]="_error"></i>
      <i class="fal fa-exclamation-triangle" [hidden]="!_error"></i>
    </div>
    <div class="blackjack-game-content" *ngIf="!_loading && data">
      <div class="blackjack-card-canvas">
        <div class="deck-cards">
          <div class="blackjack-card-container cards-5">
            <div class="blackjack-card card-container" *ngFor="let card of firstCards; let index = index">
              <div class="card__styled_card" [ngStyle]="{ left: index * 2.5 + 'em' }">
                <div
                  class="game-card card__front"
                  style="transform: rotateY(0deg)"
                  [ngClass]="'__card_' + getCardName(card)"
                ></div>
                <div class="game-card card__back" style="transform: rotateY(180deg)"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="deck-cards">
          <div class="blackjack-card-container cards-5">
            <div class="blackjack-card card-container" *ngFor="let card of newCards; let index = index">
              <div class="card__styled_card" [ngStyle]="{ left: index * 2.5 + 'em' }">
                <div
                  class="game-card card__front"
                  style="transform: rotateY(0deg)"
                  [ngClass]="'__card_' + getCardName(card)"
                ></div>
                <div class="game-card card__back" style="transform: rotateY(180deg)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./reply-video-poker.component.scss'],
})
export class ReplyVideoPokerComponent extends ReplyAbstractComponent implements OnChanges {
  data: any = null;
  deck: Array<number> = [];
  firstCards: Array<number> = [];
  newCards: Array<number> = [];

  constructor(protected socket: SocketService, protected balanceHistory: BalanceHistoryService) {
    super(socket, balanceHistory);
  }

  protected initialize(data: any) {
    if (data.game !== 'video-poker') {
      this._error = true;
      return;
    }

    this.data = data.gameData;
    this.data.generated = false;
    this.data.game = 'video-poker';
    this.prepareDeck();
  }

  protected generateGame() {
    const deck = this.reconstructDeck(this.serverSeed, this.playerSeed);
    this.data = {
      shuffledDeck: deck,
      generated: true,
      game: 'video-poker',
    };
    this.prepareDeck();
  }

  prepareDeck() {
    this.firstCards = this.data.shuffledDeck.slice(0, 5);
    this.newCards = this.data.shuffledDeck.slice(5, 10);
    this._loading = false;
  }

  getCardName(card: number): string {
    return cardMap[card % 52];
  }

  reconstructDeck(srvSeed: string, clientSeed: string) {
    const deck = [];
    for (let i = 0; i < 52; i++) {
      // 1 deck
      deck.push(i);
    }
    return this.shuffleDeck(deck, srvSeed, clientSeed);
  }

  private shuffleDeck(deck: Array<number>, serverSeed: string, clientSeed: string) {
    serverSeed = serverSeed.replace('0x', '');
    clientSeed = clientSeed.replace('0x', '');

    const clSeedSplitted = clientSeed.match(/.{1,6}/g);
    const srvSeedSplitted = serverSeed.match(/.{1,6}/g);
    const seedsCombined = clSeedSplitted.concat(srvSeedSplitted).map(item => parseInt(item, 16));

    const mt = new MersenneTwister();
    mt.seedArray(seedsCombined);
    for (let i = 0; i < 800000; i++) {
      mt.real();
    }

    const shuffledDeck = deck.slice(0);
    for (let i = shuffledDeck.length - 1; i > 0; i -= 1) {
      const j = Math.floor(mt.real() * (i + 1));
      const temp = shuffledDeck[i];
      shuffledDeck[i] = shuffledDeck[j];
      shuffledDeck[j] = temp;
    }

    return shuffledDeck;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-video-poker.component.ts